// extracted by mini-css-extract-plugin
export default {"seg":"Segmented_seg__GptdD","on":"Segmented_on__pP0FA"};